//import React, { useState, useEffect } from 'react';

type FilterType = {
  [key: string]: { group: string; label: string; query: string };
};

type FacetType = {
  [key: string]: { label: string; query: string };
};

type SortType = {
  [key: string]: { label: string; field: string };
};

export type HierarchicalFacetValue = {
  CN: string;
  term: string;
};

type HierarchicalFacetType = {
  [key: string]: {
    label: string;
    CN: string;
  };
};

interface SearchValue {
  source: string;
  text: string;
}

export type SearchType = {
  identifier: string;
  field: string;
  searchValues: SearchValue[];
  params: Object
};

interface CustomSearchCriterion {
  field: string;
  fieldLabel: string;
  searchValues: string[];
  description: string;
}

interface BasketFilter {
  basketId: string;
  basketName: string;
}

export class Search implements SearchType {
  public identifier: string;
  public field: string;
  public searchValues: SearchValue[];
  public params: Object;

  constructor(identifier: string, field: string, searchValues: SearchValue[] = [], params: Object) {
    this.identifier = identifier;
    this.field = field;
    this.searchValues = searchValues;
    this.params = params;
  }
}

class CC {
  public Searches: Search[] = [];
  matchAllCriteria: boolean = true;
  public filters: string[] = []; // This will store the filter keys the user selects
  public facets: { [field: string]: string[] } = {}; // This will store the facet fields the user selects
  public hierarchicalFacets: { [key: string]: HierarchicalFacetValue[] } = {};
  public customSearchCriteria: CustomSearchCriterion[] = [];
  public basketFilters: BasketFilter[] = [];
  public sort: string = "objectNumber"; //#0 of sortTypes

  //constructor() {}
}

class CcConfig {

  simpleSearchFields: {
    [key: string]: {
      field: string;
      browse: boolean;
      range: boolean;
    };
  } = {
    "All search fields": {
      field: "record/title, /record/auteur, /record/objectnumber",
      browse: false,
      range: false
    },
    "Title": {
      field: "/record/title",
      browse: true,
      range: false
    },
    "Object Number": {
      field: "/record/objectnumber",
      browse: true,
      range: false
    },
    "Artist": {
      field: "/record/cartelcreator", 
      browse: true,
      range: false
    },
/*    "ConLinkedToOrigins": {
      field: "/record/conlinkedtoorigins", //cartelcreator
      browse: true,
      range: false
    },
    "ConLinkedToAcquisitions": {
      field: "/record/conlinkedtoacquisitions", //cartelcreator
      browse: true,
      range: false
    },
    "ConLinkedToObjects": {
      field: "/record/conlinkedtoobjects", //cartelcreator
      browse: true,
      range: false
    },
*/    "Dated": {
      field: "/record/datebegin", // to add ,/record/dated,/record/dateend", 
      browse: false,
      range: true
    },
    "Modalités d'acquisition": {
      field: "/record/accessionmethod",
      browse: true,
      range: false
    },
    "Date d'acquisition": {
      field: "/record/accessionyear",
      browse: false,
      range: true
    },
    "Materials and techniques": {
      field: "/record/thesmaterial",
      browse: true,
      range: false
    },
    "Inscriptions": {
      field: "/record/inscribed",
      browse: false,
      range: false
    },
    "Provenance": {
      field: "/record/provenance",
      browse: true,
      range: false
    },
    "Thème": {
      field: "/record/thesthemes",
      browse: true,
      range: false
    },
    "Nature de l'objet": {
      field: "/record/classification",
      browse: true,
      range: false
    },
    "Emplacement actuel": {
      field: "/record/location/site",
      browse: true,
      range: false
    },
    "Exposition permanente": {
      field: "/record/locmuseecollection",
      browse: true,
      range: false
    },
    "Prêts ou dépots": {
      field: "/record/objoutside",
      browse: true,
      range: false
    },
    "Collections": {
      field: "/record/collection",
      browse: true,
      range: false
    }
  };

  //advancedSearchFields is not being used anymore!!!
  advancedSearchFields: {
    [key: string]: {
      field: string;
      browse: boolean;
    };
  } = {
    "Title": {
      field: "/record/title",
      browse: true,
    },
    "Object Number": {
      field: "/record/objectnumber",
      browse: true,
    },
    "Personnes et institutions": {
      field: "/record/sortname,/record/conxother/conxother",
      browse: true,
    },
    "Dated": {
      field: "/record/datebegin", // to add /record/dated,/record/dateend
      browse: true,
    },
    "Materials and techniques": {
      field: "/record/thesmaterial",
      browse: true,
    },
    "Nature de l'objet": {
      field: "/record/classification",
      browse: true,
    },
    "Inscriptions": {
      field: "/record/inscribed",
      browse: false,
    },
    "Provenance": {
      field: "/record/provenance",
      browse: false,
    },
    "Date de l'acquisition": {
      field: "/record/accessiondate",
      browse: false,
    },
    "Modalites d'acquisition": {
      field: "/record/accessionmethod",
      browse: false,
    },
    "Emplacement actuel": {
      field: "/record/location/site",
      browse: true,
    },
    "Exposition permanente": {
      field: "/record/locmusseecollection",
      browse: true,
    },
    "Objets hors les murs": {
      field: "/record/objoutside",
      browse: true,
    },
    "Collections": {
      field: "/record/collection",
      browse: true,
    }
  };

  mobileSearchFields: {
    [key: string]: {
      field: string;
      browse: boolean;
    };
  } = {
    "All search fields": {
      field: "*",
      browse: false,
    },
    "Title": {
      field: "/record/title",
      browse: true,
    },
    "Object Number": {
      field: "/record/objectnumber",
      browse: true,
    },
    "Artist": {
      field: "/record/cartelcreator",
      browse: true,
    },
    "Dated": {
      field: "/record/datebegin,/record/dated,/record/dateend",
      browse: true,
    },
    "Materials and techniques": {
      field: "/record/medium",
      browse: true,
    },
    "Inscriptions": {
      field: "/record/inscribed",
      browse: false,
    },
    "Historical comment": {
      field: "/record/provenance",
      browse: false,
    },
    "Thème": {
      field: "/record/theme",
      browse: true,
    },
    "Nature de l'objet": {
      field: "/record/classification",
      browse: true,
    },
    "Date d'acquisition": {
      field: "/record/accessiondate",
      browse: true,
    },
    "Provenance": {
      field: "/record/provenance",
      browse: true,
    },
    "Emplacement actuel": {
      field: "/record/locmuseesalle",
      browse: true,
    },
    "Exposition permanente": {
      field: "/record/locmuseecollection",
      browse: true,
    }
  };

  filters: FilterType = {
    filter_objects: { group: "A", label: "Uniquement avec images", query: "/record/avecimage=Uniquement avec images" },
    filter_icono: { group: "A", label: "Iconography", query: "/Record/source=icono" },
    filter_freeOfRights: { group: "B", label: "Free to use Images", query: "CN=[ICO.AAN.AAB.AAC]" },
  };

  facets: FacetType = {
    location: { label: "facet_location", query: "/record/location" },
    personnes: { label: "facet_persons", query: "/record/sortname" },
    medium: { label: "facet_medium", query: "/record/thesmaterial" },
  };

  hierarchicalFacets: HierarchicalFacetType = {
    medium: { label: "facet_medium", CN: "MAM.AAB"},
    themes: { label: "facet_themes", CN: "MAM.AAA" },
  }

  // !! do not change the order of the sort params
  sort: SortType = {
    objectNumber: {label: "Object number", field: "/record/objectnumber,/record/objectnumber2"},
    relevance: {label: "Relevance", field: "ccRelevance"},
    title: {label: "Title", field: "/record/sorttitle"},
    date: {label: "Date(s)", field: "/record/datebegin"},
    location: {label: "Location", field: "/record/location"}
  }

}

let ccConfig = new CcConfig();

export { CC, ccConfig };
